<template>
	<CDialog
		:visible="visible"
		custom-class="money-back-guarantee-dialog dialog--tiny"
		data-testid="money-back-guarantee-dialog"
		@closed="$emit('closed')"
	>
		<div class="flex flex-col items-center gap-4">
			<Inline svg="images/money-badge" class="w-33" />
			<h1 class="dialog__title mb-0 text-center w-full">
				30-Day Money-Back Guarantee
			</h1>
			<p class="text-left">We think you'll love Cognito Forms, but we want you to make this commitment with confidence. If it's not the right fit for your team, contact us within 30 days of your purchase and we'll refund your payment in full.</p>
		</div>
	</CDialog>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';
	import CDialog from 'src/components/dialogs/Dialog.vue';

	export default defineComponent({
		name: 'CMoneyBackGuaranteeDialog',
		components: { CDialog },
		props: {
			visible: { type: Boolean, default: false }
		},
		emits: ['closed']
	});
</script>

<style lang="scss">
.money-back-guarantee-dialog {

	.el-dialog__header {
		padding-bottom: 0;
	}
}
</style>
